module.exports = "<div class=\"well\"><a routerLink=\"/lugares\">Lugares</a> / {{elLugar.name}}</div>\n\n<div class=\"container\">\n\t<h1>{{elLugar.name}}</h1>\n\t<hr>\n\t<small>{{elLugar.distancia}}kms</small>\n\t<br>\n\t<div class=\"well\">\n\t\t<p>\n\t\t\t{{elLugar.descripcion}}\n\t\t</p>\n\t\t<strong>\n\t\t\tSuscripcion:\n\t\t</strong>\n\t\t<span>{{elLugar.plan}}</span>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/detalle/detalle.component.html
// module id = ../../../../../src/app/detalle/detalle.component.html
// module chunks = main